import { useLocation } from 'react-router-dom';

export function useGroupType() {
  
  const location = useLocation();
  const type = location.pathname.split('/')[4] || '';
  const isCopPage = type.toLowerCase().startsWith('dh_coe_')||type.toLowerCase().startsWith('_coe')
  const isOthers = type.toLowerCase().startsWith('dh_vs_')|| type.toLowerCase().startsWith('_vs')|| 
                    type.toLowerCase().startsWith('dh_art_')|| type.toLowerCase().startsWith('_art')||
                    type.toLowerCase().startsWith('dh_plt_')||type.toLowerCase().startsWith('_plt')||
                    type.toLowerCase().startsWith('dh_team_chapter')||
                    type.toLowerCase().startsWith('dh_tech_')|| type.toLowerCase().startsWith('_tech');
  return { isCopPage,isOthers };
}
